import {DataFetcher} from '@aboutyou/data-fetcher';
import {lazy} from '@aboutyou/lazy-imports';
import {
  useIsArticleDetailPage,
  useIsBasketPage,
  useIsBrandPage,
  useIsCategoryPage,
  useIsDropPage,
  useIsHomePage,
  useIsOutfitDetailPage,
  useIsStoryPage,
  useIsWishlistPage,
} from '@aboutyou/router';
import React from 'react';
import {filterSimpleAndAppInstallIncentiveCampaigns} from '../discountsHelper';
import {useDiscounts} from '../hooks/useDiscounts';

const LazyDiscountStickyBar = lazy(() =>
  import('./DiscountStickyBar.eager').then(mod => ({
    default: mod.DiscountStickyBarEager,
  })),
);

export const DiscountStickyBar = () => {
  const request = useDiscounts();
  const isHomePage = useIsHomePage();
  const isCategory = useIsCategoryPage();
  const isBrandPage = useIsBrandPage();
  const isADP = useIsArticleDetailPage();
  const isBasket = useIsBasketPage();
  const isWishlist = useIsWishlistPage();
  const isStory = useIsStoryPage();
  const isOutfitDetailPage = useIsOutfitDetailPage();
  const isDropPage = useIsDropPage();

  return isCategory ||
    isHomePage ||
    isBrandPage ||
    isADP ||
    isBasket ||
    isWishlist ||
    isStory ||
    isOutfitDetailPage ||
    isDropPage ? (
    <DataFetcher
      request={request}
      Error={null}
      View={props =>
        filterSimpleAndAppInstallIncentiveCampaigns(props.discounts).length >
        1 ? (
          <LazyDiscountStickyBar discounts={props} />
        ) : null
      }
    />
  ) : null;
};
